//***** MetaDataLists - List Columns *****//

// Category
export const CategoryCols = {
  Category: 'Category',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
}
// SubCategory
export const SubCategoryCols = {
  Category: 'Category',
  CheckListNames: 'CheckListNames',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  SubCategory: 'SubCategory',
}
// CheckList
export const CheckListCols = {
  Description: 'Description',
  DocLink: 'DocLink',
  EKey: 'eKey',
  ETag: 'eTag',
  Form: 'Form',
  ID: 'ID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  LongName: 'LongName',
}
// Status
export const StatusCols = {
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Status: 'Status',
}
// AssignedComponent
export const AssignComponentCols = {
  AssignedComponent: 'AssignedComponent',
  AssignedComponentCode: 'AssignedComponentCode',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
}
// From Tooltips
export const TooltipsCols = {
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  TooltipDescription: 'TooltipDescription',
  TooltipID: 'TooltipID',
  TooltipName: 'TooltipName',
}
// Rank
export const RankCols = {
  Abbreviation: 'Abbreviation',
  AssignedComponent: 'AssignedComponent',
  EKey: 'eKey',
  ETag: 'eTag',
  Grade: 'Grade',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Rank: 'Rank',
  Status: 'Status',
}
// OACOBAN
export const OACOBANCols = {
  AssignedComponent: 'AssignedComponent',
  CPTS: 'CPTS',
  Category: 'Category',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM',
  OAC: 'OAC',
  OBAN: 'OBAN',
}
// PASCODE
export const PASCODECols = {
  AssignedComponent: 'AssignedComponent',
  EKey: 'eKey',
  ETag: 'eTag',
  HostCPTS: 'HostCPTS',
  HostMAJCOM: 'HostMAJCOM',
  ID: 'ID',
  Installation: 'Installation',
  IsArchived: 'IsArchived', // //IsArchive
  IsRegAFDirect: 'IsRegAFDirect',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM',
  OrgMAJCOM: 'OrgMAJCOM',
  Organization: 'Organization',
  PASCODE: 'PASCODE',
  ServicingCPTS: 'ServicingCPTS',
}
// ServiceBase
export const ServiceBaseCols = {
  AssignedComponent: 'AssignedComponent',
  Base: 'Base',
  CPTS: 'CPTS',
  CPTSFriendlyName: 'CPTSFriendlyName',
  EKey: 'eKey',
  ETag: 'eTag',
  GroupName: 'GroupName',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM',
}
// ProfileStatus
export const ProfileStatusCols = {
  AssignedComponent: 'AssignedComponent',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Status: 'Status',
  StatusCode: 'StatusCode',
}
//HelpDesk
export const HelpDeskCols = {
  AssignedComponent: 'AssignedComponent',
  EKey: 'eKey',
  ETag: 'eTag',
  EmailAddress: 'EmailAddress',
  ID: 'ID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Office: 'Office',
  PhoneNumber: 'PhoneNumber',
}
//SystemHelpDesk
export const SystemHelpDeskCols = {
  EKey: 'eKey',
  ETag: 'eTag',
  EmailAddress: 'EmailAddress',
  HoursOfOperation: 'HoursOfOperation',
  ID: 'ID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Office: 'Office',
  PhoneNumber: 'PhoneNumber',
}
//ProcessFlow
export const ProcessFlowCols = {
  AssignToOptions: 'AssignToOptions',
  AssignedComponent: 'AssignedComponent',
  Category: 'Category', //Lookup
  EKey: 'eKey',
  ETag: 'eTag',
  ElevateToOptions: 'ElevateToOptions',
  ID: 'ID',
  IsActionOutsideCSP: 'IsActionOutsideCSP', //PendingActionOutsideCSP
  IsAssign: 'IsAssign', //AssignTo
  IsCancel: 'IsCancel', //Cancel
  IsClose: 'IsClose', //Close
  IsEditDV: 'IsEditDV', //EditDV
  IsElevate: 'IsElevate', //Elevate
  IsFormEdit: 'IsFormEdit', //FormEdit
  IsReopen: 'IsReopen', //Reopen
  IsResolve: 'IsResolve', //Resolve
  IsRespond: 'IsRespond', //Respond
  IsSend: 'IsSend', //SendTo
  IsSendToHost: 'IsSendToHost', //SendToHost
  IsViewDV: 'IsViewDV', //ViewDV
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Order: 'Order', //Orderby
  SendToOptions: 'SendToOptions',
  Status: 'Status', //Lookup
  UserRole: 'UserRole', //Title
  UserType: 'UserType',
}

//***** Content - List Columns *****//

// KBArticles
export const KBArticlesCols = {
  AssignedComponent: 'AssignedComponent',
  CPTS: 'CPTS',
  Category: 'Category',
  Description: 'Description',
  EKey: 'eKey',
  ETag: 'eTag',
  FY: 'FY',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM',
  QID: 'QID',
  Role: 'Role',
  Title: 'Title',
}
// FAQ
export const FAQCols = {
  Answer: 'Answer',
  AssignedComponent: 'AssignedComponent',
  CPTS: 'CPTS',
  Category: 'Category',
  Description: 'Description',
  EKey: 'eKey',
  ETag: 'eTag',
  FY: 'FY',
  ID: 'ID',
  IsArchived: 'IsArchived',
  IsPromotedKnowlegeBase: 'IsPromotedKnowlegeBase',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM',
  QID: 'QID',
  Question: 'Question',
  Role: 'Role',
  SubCategory: 'SubCategory',
}
// QuickLinks
export const QuickLinksCols = {
  AssignedComponent: 'AssignedComponent',
  CPTS: 'CPTS',
  EKey: 'eKey',
  ETag: 'eTag',
  FY: 'FY',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM',
  Name: 'Name',
  Role: 'Role',
  URL: 'URL',
}
// POC
export const POCCols = {
  AssignedComponent: 'AssignedComponent',
  CPTS: 'CPTS',
  Category: 'Category',
  EKey: 'eKey',
  ETag: 'eTag',
  FY: 'FY',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM',
  POCName: 'POCName',
  PhoneNumber: 'PhoneNumber',
  Role: 'Role',
}
// Announcements
export const AnnouncementsCols = {
  AssignedComponent: 'AssignedComponent',
  Body: 'Body',
  CPTS: 'CPTS',
  Category: 'Category',
  EKey: 'eKey',
  ETag: 'eTag',
  ExpiryDate: 'ExpiryDate',
  FY: 'FY',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM',
  Role: 'Role',
  Tags: 'Tags',
  Title: 'Title',
}

// Calendar
export const CalendarCols = {
  AssignedComponent: 'AssignedComponent',
  CPTS: 'CPTS',
  CalendarType: 'CalendarType',
  Category: 'Category',
  Description: 'Description',
  EKey: 'eKey',
  ETag: 'eTag',
  EndDate: 'EndDate',
  EventCategory: 'EventCategory',
  FY: 'FY',
  ID: 'ID',
  IsAllDayEvent: 'IsAllDayEvent',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Location: 'Location',
  MAJCOM: 'MAJCOM',
  RRule: 'rrule',
  Role: 'Role',
  StartDate: 'StartDate',
  Title: 'title',
}

//***** Applications - List Columns *****//
// Profile
export const UserProfileCols = {
  AssignedComponent: 'AssignedComponent',
  CustomerID: 'CustomerID',
  DODIDNumber: 'DODIDNumber',
  DisplayName: 'DisplayName',
  DutyEmail: 'DutyEmail',
  DutyPhone: 'DutyPhone',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  PASCODE: 'PASCODE',
  Rank: 'Rank',
  StatusCode: 'StatusCode',
  UserID: 'UserID',
}
//Inquiry
export const InquiryCols = {
  Action: 'Action',
  AssignedComponent: 'AssignedComponent',
  AssignedTo: 'AssignedTo',
  AssignedUsers: 'AssignedUsers',
  CPTS: 'CPTS',
  Canceledby: 'Canceledby',
  Category: 'Category',
  ClosedDate: 'ClosedDate',
  Closedby: 'Closedby',
  CreatedForSelf: 'CreatedForSelf',
  CustomerActionRequiredDate: 'CustomerActionRequiredDate',
  CustomerActionUsername: 'CustomerActionUsername',
  CustomerActionUserrole: 'CustomerActionUserrole',
  CustomerID: 'CustomerID',
  DODNumber: 'DODNumber',
  DisplayName: 'DisplayName',
  DutyEmail: 'DutyEmail',
  DutyPhone: 'DutyPhone',
  EKey: 'eKey',
  ETag: 'eTag',
  FY: 'FY',
  FormStatus: 'FormStatus',
  ID: 'ID',
  InquiryBucket: 'InquiryBucket',
  InquiryDescription: 'InquiryDescription',
  InquiryDetails: 'InquiryDetails',
  InquiryFor: 'InquiryFor',
  InquiryNumber: 'InquiryNumber',
  InquiryTitle: 'InquiryTitle',
  // CustomerReminderEmailSent: 'CustomerReminderEmailSent',
  IsArchived: 'IsArchived',
  IsCustomerActionRequired: 'IsCustomerActionRequired',
  IsDV: 'IsDV',
  IsDeleted: 'IsDeleted',
  IsFormUpdated: 'IsFormUpdated',
  IsHostResponded: 'IsHostResponded',
  IsInquirySentToHost: 'IsInquirySentToHost',
  IsMainItemUpdated: 'IsMainItemUpdated',
  IsOutsideActionComplete: 'IsOutsideActionComplete',
  IsPendingOutsideAction: 'IsPendingOutsideAction',
  IsReturnedToCPTS: 'IsReturnedToCPTS',
  IsSubmitted: 'IsSubmitted',
  IsSurveySubmitted: 'IsSurveySubmitted',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemGUID: 'ItemGUID',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM',
  ModeOfInquiry: 'ModeOfInquiry',
  OAC: 'OAC',
  OBAN: 'OBAN',
  OrgMAJCOM: 'OrgMAJCOM',
  OutsideActionCompleteDate: 'OutsideActionCompleteDate',
  PASCODE: 'PASCODE',
  PASCODECPTS: 'PASCODECPTS',
  PASCODEHostCPTS: 'PASCODEHostCPTS',
  PASCODEHostMAJCOM: 'PASCODEHostMAJCOM',
  PASCODEId: 'PASCODEId',
  PASCODEInstallation: 'PASCODEInstallation',
  PASCODEMAJCOM: 'PASCODEMAJCOM',
  PASCODEOrganization: 'PASCODEOrganization',
  PendingOutsideActionDate: 'PendingOutsideActionDate',
  PreviousStatus: 'PreviousStatus',
  Priority: 'Priority',
  ProfileAssignedComponent: 'ProfileAssignedComponent',
  Rank: 'Rank',
  ReopenedDate: 'ReopenedDate',
  RequestFor: 'RequestFor',
  ResolvedBy: 'ResolvedBy',
  ResolvedDate: 'ResolvedDate',
  ReturnedToCPTSDate: 'ReturnedToCPTSDate',
  ReturnedtoCPTSUsername: 'ReturnedtoCPTSUsername',
  ReturnedtoCPTSUserrole: 'ReturnedtoCPTSUserrole',
  Status: 'Status',
  StatusModifiedDate: 'StatusModifiedDate',
  SubCategory: 'SubCategory',
  TeamMembers: 'TeamMembers',
  UserID: 'UserID',
}
//Archived Inquiry Cols
export const ArchivedInquiryCols = {
  ...InquiryCols,
  ArchivedDate: 'ArchivedDate',
}
//Inquiry History
export const HistoryCols = {
  Action: 'Action',
  AssignedComponent: 'AssignedComponent',
  AssignedTo: 'AssignedTo',
  Description: 'Description',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  InquiryID: 'InquiryID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemGUID: 'ItemGUID',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  PreviousStatus: 'PreviousStatus',
  Role: 'Role',
  RoleType: 'RoleType',
  Status: 'Status',
  Title: 'Title',
}
//Inquiry Discussion
export const DiscussionCols = {
  AppID: 'AppID',
  AssignedComponent: 'AssignedComponent',
  Comment: 'Comment',
  CommentDocumentName: 'CommentDocumentName',
  CommentType: 'CommentType',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  InquiryGUID: 'InquiryGUID',
  InquiryID: 'InquiryID',
  IsActionComment: 'IsActionComment',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ParentCommentCode: 'ParentCommentCode',
  Subject: 'Subject',
  Title: 'Title',
  UserRole: 'UserRole'
}
//Inquiry LastAction
export const LastActionCols = {
  Action: 'Action',
  AssignedComponent: 'AssignedComponent',
  CPTS: 'CPTS',
  CustomerID: 'CustomerID',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  InquiryID: 'InquiryID',
  IsSentToHost: 'IsSentToHost', //IsInquirySentToHost
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemGUID: 'ItemGUID', //InquiryGUID
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM',
  PASCODEHostCPTS: 'PASCODEHostCPTS', // PAScodeCPTS
  PASCODEHostMAJCOM: 'PASCODEHostMAJCOM', // PASCodeMAJCOM
  Role: 'Role',
  UserID: 'UserID',
}
//Inquiry Teammembers
export const InquiryTeammembersCols = {
  AssignedComponent: 'AssignedComponent',
  CommentDocumentName: 'CommentDocumentName',
  EKey: 'eKey',
  ETag: 'eTag',
  FirsttimeCreation: 'FirsttimeCreation',
  ID: 'ID',
  InquiryID: 'InquiryID',
  IsDeleted: 'IsDeleted',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemGUID: 'ItemGUID',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  RecentlyAddedMember: 'RecentlyAddedMember',
  RecentlyDeletedMember: 'RecentlyDeletedMember',
  TeamMembers: 'TeamMembers',
  Title: 'Title',
}
// FeedBack
export const FeedBackCols = {
  CPTS: 'CPTS',
  EKey: 'eKey',
  ETag: 'eTag',
  FeedBackAbout: 'FeedBackAbout',
  ID: 'ID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Message: 'Message',
  Role: 'Role',
  Subject: 'Subject',
}

// Notifications list
export const NotificationCols = {
  Action: 'Action', //Event
  AlertType: 'AlertType',
  AssignedComponent: 'AssignedComponent',
  CPTS: 'CPTS',
  Category: 'Category',
  CustomerName: 'CustomerName',
  EKey: 'eKey',
  ETag: 'eTag',
  EmailBody: 'EmailBody',
  FromUser: 'FromUser',
  ID: 'ID',
  InquiryID: 'InquiryID',
  InquiryItemID: 'InquiryItemID',
  InquiryTitle: 'InquiryTitle',
  IsRead: 'IsRead',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemGUID: 'ItemGUID',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM',
  Read: 'Read',
  Status: 'Status',
  Subject: 'Subject',
  Title: 'Title',
  To: 'To',
  UserRole: 'UserRole',
}

// Notifications Metadata List
export const NotificationMetadataCols = {
  Activity: 'Activity',
  AlertType: 'AlertType',
  AssignedComponent: 'AssignedComponent',
  Category: 'Category',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Role: 'Role',
  Status: 'Status',
  Subject: 'Subject',
  ToUserRoles: 'ToUserRoles',
  ToUsers: 'ToUsers',
}

// ActivityMetadata
export const ActiveMetadataCols = {
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Title: 'Title',
}
// EmailLog
export const EmailLogCols = {
  Action: 'Action',
  AssignedComponent: 'AssignedComponent',
  Body: 'Body',
  EKey: 'eKey',
  ETag: 'eTag',
  ErrorInformation: 'ErrorInformation',
  From: 'From',
  ID: 'ID',
  InquiryID: 'InquiryID',
  IsMailSent: 'IsMailSent',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemGUID: 'ItemGUID',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Role: 'Role',
  Subject: 'Subject',
  Title: 'Title',
  To: 'To',
}
// PII Formates
export const PIIFormateCols = {
  EKey: 'eKey',
  ETag: 'eTag',
  Format: 'Format', //FORMAT
  FormatExample: 'FormatExample',
  FormatRegExp: 'FormatRegExp', //FORMATREGEXP
  ID: 'ID',
  IsEnable: 'IsEnable', //FromatEnable
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  PID: 'PID',
  Title: 'Title',
}

export const PIICategoryCols = {
  CID: 'CID',
  CategoryContext: 'CategoryContext', //CATEGORYCONTEXT
  CategoryParamName: 'CategoryParamName', //CATEGORYPARAMNAME
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  IsEnable: 'IsEnable', //ParamEnable
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ParamAllowedDataTypes: 'ParamAllowedDataTypes',
  ParamMode: 'ParamMode', //PARAMMODE
  Severity: 'Severity',
  Title: 'Title',
}

export const PIICategoryTypeCols = {
  CID: 'CID',
  CategoryName: 'CategoryName', //CATEGORYNAME
  CategoryType: 'CategoryType', //CATEGORYTYPE
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Title: 'Title',
}
export const PIIAuditTrailCols = {
  Comment: 'Comment',
  DocumentPath: 'DocumentPath',
  EKey: 'eKey',
  ETag: 'eTag',
  EntityID: 'EntityID',
  EntityType: 'EntityType',
  FieldorFileName: 'FieldorFileName', //Field/FileName
  ID: 'ID',
  InquiryID: 'InquiryID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemGUID: 'ItemGUID',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  JsonResult: 'JsonResult',
  UserAnswer: 'UserAnswer',
}

// ScanList
export const ScanListCols = {
  EKey: 'eKey',
  ETag: 'eTag',
  ExtraData: 'ExtraData',
  FindingsString: 'FindingsString',
  ID: 'ID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  RecordsScanned: 'RecordsScanned',
  ScanCreatedByUser: 'ScanCreatedByUser',
  ScanCreatedDate: 'ScanCreatedDate',
  ScanId: 'ScanId',
  ScanOccuranceRecordsDetected: 'ScanOccuranceRecordsDetected',
  ScanRecordsDetected: 'ScanRecordsDetected',
  ScanStatus: 'ScanStatus',
  Title: 'Title',
}

// ScanItemGroupedList
export const ScanItemGroupedListCols = {
  DocName: 'DocName',
  DocUrl: 'DocUrl',
  EKey: 'eKey',
  ETag: 'eTag',
  ExtraData: 'ExtraData',
  FieldEntityPropertyName: 'FieldEntityPropertyName',
  FieldId: 'FieldId',
  FieldTitle: 'FieldTitle',
  FindingsString: 'FindingsString',
  FoundText: 'FoundText',
  GroupedItemUUID: 'GroupedItemUUID',
  ID: 'ID',
  IsDoc: 'IsDoc',
  IsListItem: 'IsListItem',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ListId: 'ListId',
  ListItemGUID: 'ListItemGUID',
  ListItemID: 'ListItemID',
  ListItemIdUri: 'ListItemIdUri',
  ListTitle: 'ListTitle',
  PostRenderText: 'PostRenderText',
  PreRenderText: 'PreRenderText',
  ResultsArray: 'ResultsArray',
  ScanId: 'ScanId',
  Title: 'Title',
  TotalOccurrencesCount: 'TotalOccurrencesCount',
}

// ScanDetailList
export const ScanDetailListCols = {
  DocName: 'DocName',
  DocUrl: 'DocUrl',
  EKey: 'eKey',
  ETag: 'eTag',
  ExtraData: 'ExtraData',
  FieldEntityPropertyName: 'FieldEntityPropertyName',
  FieldId: 'FieldId',
  FieldTitle: 'FieldTitle',
  FoundText: 'FoundText',
  ID: 'ID',
  IsDoc: 'IsDoc',
  IsListItem: 'IsListItem',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ListId: 'ListId',
  ListItemGUID: 'ListItemGUID',
  ListItemID: 'ListItemID',
  ListItemIdUri: 'ListItemIdUri',
  ListTitle: 'ListTitle',
  PiiParam: 'PiiParam',
  PiiParamMatchCount: 'PiiParamMatchCount',
  PostRenderText: 'PostRenderText',
  PreRenderText: 'PreRenderText',
  ScanId: 'ScanId',
  ScanItemGroupId: 'ScanItemGroupId',
  Title: 'Title',
}

//SURVEY SITE LISTS

export const SurveyRequiredCols = {
  AssignedComponent: 'AssignedComponent',
  CustomerDOD: 'CustomerDOD',
  CustomerEmail: 'CustomerEmail',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  InquiryID: 'InquiryID', //CSPInquiryTitle
  IsFeedbackRequired: 'IsFeedbackRequired', //FeedbackRequired
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemGUID: 'ItemGUID', //CSPInquiryGUID
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  MAJCOM: 'MAJCOM', // ServicingMajcom
  Section: 'Section',
  ServicingOrganization: 'ServicingOrganization',
  SurveyGUID: 'SurveyGUID'
}

export const SurveyFormCols = {
  AssignedComponent: 'AssignedComponent',
  CPTS: 'CPTS',
  Comments: 'Comments',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  InquiryID: 'InquiryID', //InquiryId
  InquiryItemID: 'InquiryItemID', //InquiryItemId
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemGUID: 'ItemGUID', //CSPInquiryGUID
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  LikelyToUseForFutureInquiries: 'LikelyToUseForFutureInquiries',
  MAJCOM: 'MAJCOM',
  MPFMadeItEasyForMe: 'MPFMadeItEasyForMe',
  OverallSatisfactionForTheResolution: 'OverallSatisfactionForTheResolution',
  SatisfactionOnQualityOfYourService: 'SatisfactionOnQualityOfYourService',
  SatisfactionOnResolutionTimeliness: 'SatisfactionOnResolutionTimeliness',
  ServicingOrganization: 'ServicingOrganization',
  SurveyGUID: 'SurveyGUID',
}
export const EmailActionMetadataCols = {
  Activity: 'Activity',
  AssignedEmailBody: 'AssignedEmailBody',
  AssignedSubject: 'AssignedSubject',
  CustomerEmailBody: 'CustomerEmailBody',
  CustomerSubject: 'CustomerSubject',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  InvolvedEmailBody: 'InvolvedEmailBody',
  InvolvedSubject: 'InvolvedSubject',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
}

export const AccessGroupsCols = {
  Description: 'Description',
  EKey: 'eKey',
  ETag: 'eTag',
  EditMembership: 'EditMembership',
  GroupMembers: 'GroupMembers',
  GroupOwners: 'GroupOwners',
  ID: 'ID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  PermissionLevels: 'PermissionLevels',
  Title: 'Title',
  ViewMemberships: 'ViewMemberships',
}
export const ActivePermissionGroupsCols = {
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  IsActive: 'IsActive',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Title: 'Title',
}

export const LastModifiedDateCols = {
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ListName: 'ListName',
  VCount: 'VCount',
}

export const ChatMessagesCols = {
  ChatHTML: 'ChatHTML',
  ChatReplies: 'ChatReplies',
  ChatType: 'ChatType',
  Customer: 'Customer',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  InquiryTitle: 'InquiryTitle',
  IsClosed: 'IsClosed',
  IsDeleted: 'IsDeleted',
  IsReply: 'IsReply',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemGUID: 'ItemGUID',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Message: 'Message',
  ParentChatID: 'ParentChatID',
  Participants: 'Participants',
  ParticipantsGroup: 'ParticipantsGroup',
  ReadBy: 'ReadBy',
  SeenBy: 'SeenBy',
  SenderName: 'SenderName',
  SubmitterID: 'SubmitterID',
  UserRole: 'UserRole',
}
